import {useEffect, useState} from 'react';
import {BlogPostMeta} from 'types/blog';
import {getSimilarPosts} from 'utils/blog';
import BlogPostTile from './BlogPostTile';

export const MoreBlogPosts = ({meta}) => {
  const [similarPosts, setSimilarPosts] = useState<BlogPostMeta[]>([]);
  useEffect(() => {
    getSimilarPosts(meta).then(setSimilarPosts);
  }, [meta]);
  if (!similarPosts.length) {
    return null;
  }
  return (
    <section className="mb-24">
      <div className="flex justify-center">
        <h3 className="text-3xl">Related Posts</h3>
      </div>
      <div className="flex flex-col justify-center lg:flex-row">
        {similarPosts.map((post, idx) => (
          <div className="w-full p-4 lg:w-1/3" key={post.link}>
            <BlogPostTile post={post} index={idx} numberOfTagsToShow={6} />
          </div>
        ))}
      </div>
    </section>
  );
};
